import config from "../../config";
import { isAuthToken, type AuthToken } from "./AuthToken";

export class TokenApis {
  /**
   * Exchanges an Auth0 ID token for an existing WorkUI application token.
   */
  public static async exchangeAuth0Token(idToken: string): Promise<AuthToken> {
    if (!idToken) {
      throw new Error("Missing ID token.");
    }

    const response = await fetch(`${config.apiGateway.AUTH_API}/api/token/exchange`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${idToken}`,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Token exchange failed, HTTP ${response.status}: ${response.statusText}`);
    }

    const data: unknown = await response.json();
    if (!isAuthToken(data)) {
      throw new Error("Invalid exchange token response.");
    }

    return data;
  }
}
